import { type ExperienceData, type ReportedTimings } from '@atlassian/ufo-experimental/types';

import { type BundleEvalTimingsConfig } from '../../../../../types';
import { getPerformanceObject } from '../../../utils/window-helper';

type BundleEvalTimingsPayload = {
	'timings:bundleEval': ReportedTimings;
} | null;

type InternalBundleEvalTimingsMethodPayload = (
	data: ExperienceData,
	bundleEvalTimings: BundleEvalTimingsConfig | null,
	performance?: Performance,
) => BundleEvalTimingsPayload;

export const bundleEvalTimings: InternalBundleEvalTimingsMethodPayload = (
	data,
	bundleEvalTimings,
	performance = getPerformanceObject() || undefined,
) => {
	if (!bundleEvalTimings) {
		return null;
	}

	const started: { [key: string]: PerformanceEntry } = {};
	const timings: {
		[key: string]: { duration: number; startTime: number };
	} = {};

	performance?.getEntriesByType('mark').forEach((mark) => {
		const result = bundleEvalTimings.mapPerformanceMark(mark.name);
		if (!result || data.result.startTime === null) {
			return;
		}
		const { type, name } = result;

		if (type === 'start' && mark.startTime >= data.result.startTime) {
			started[name] = mark;
			return;
		}

		if (type === 'end' && started[name]) {
			timings[name] = {
				startTime: Math.round(started[name].startTime - data.result.startTime),
				duration: Math.round(mark.startTime - started[name].startTime),
			};
			delete started[name];
		}
	});

	if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
		const result = bundleEvalTimings.additionalTimings(data.result.startTime);
		if (result) {
			Object.entries(result).forEach(([key, value]) => {
				timings[key] = value;
			});
		}
	}

	if (Object.keys(timings).length === 0) {
		return null;
	}

	return { 'timings:bundleEval': timings };
};
